<ch-loader *ngIf="!dataLoaded"></ch-loader>
<div [ngStyle]="{ display: dataLoaded ? 'block' : 'none' }">
  <ch-breadcrumb [parts]="['Offers', !offerId ? 'Duplicate' : '', isNew ? 'Add New' : establishmentName]"></ch-breadcrumb>
  <form (ngSubmit)="submit(offerForm)" #offerForm="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-9 col-md-9 pr-5">
          <div class="card mb-9">
            <div class="card-header">Offer details ( {{offerId}} )</div>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label for="deeplinking-shortLink-input">Deeplink</label>
                    <input
                      type="text"
                      name="shortLink"
                      class="form-control"
                      id="deeplinking-shortLink-input"
                      [(ngModel)]="offer.shortLink"
                      #shortLink="ngModel"
                      readonly="readonly"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label for="establishment-name-input">Establishment Name</label>
                    <input
                      type="text"
                      name="establishedName"
                      class="form-control"
                      id="establishment-name-input"
                      [(ngModel)]="offer.establishment.name"
                      #establishedName="ngModel"
                      required
                      [readonly]="formLocked"
                    />
                    <small class="text-danger" *ngIf="(establishedName.touched || establishedName.dirty) && !establishedName.valid">
                      Established Name is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="member-edit-name">Location</label>
                    <div class="edit-select">
                      <ch-live-search
                        [items]="locations"
                        [showClass]="1"
                        [nothingSelectedText]="nothingSelectedMessage"
                        (change)="locationChanged($event)"
                        [value]="offer.establishment.locationId"
                      ></ch-live-search>
                    </div>
                    <small class="text-danger" *ngIf="!isStatusDraft && !offer.establishment.locationId">
                      Location is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-addres-input">Address</label>
                    <div>
                      <textarea
                        type="text"
                        name="establishmentAddress"
                        class="form-control"
                        id="establishment-addres-input"
                        [(ngModel)]="offer.establishment.address"
                        #establishmentAddress="ngModel"
                        [required]="!isStatusDraft"
                        [readonly]="formLocked"
                      ></textarea>
                      <small
                        class="text-danger"
                        *ngIf="(establishmentAddress.touched || establishmentAddress.dirty) && !establishmentAddress.valid"
                      >
                        Address is required.
                      </small>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="offer-headline-input">Offer Headline</label>
                    <input
                      type="text"
                      name="offerHeadline"
                      class="form-control"
                      id="offer-headline-input"
                      [(ngModel)]="offer.headline"
                      #offerHeadline="ngModel"
                      [required]="!isStatusDraft"
                      [readonly]="formLocked"
                    />
                    <small class="text-danger" *ngIf="(offerHeadline.touched || offerHeadline.dirty) && !offerHeadline.valid">
                      Offer Headline is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-types-dropdown">Establishment Type</label>
                    <select
                      type="number"
                      id="offer-types-dropdown"
                      name="offerTypes"
                      class="form-control"
                      [(ngModel)]="selectedOfferTypes"
                      #offerTypes
                    >
                      <option value="null" disabled>Nothing selected</option>
                      <option *ngFor="let item of offerTypesDropdown" value="{{ item.value }}">{{ item.label }}</option>
                    </select>

                    <div class="offer-establishment-items-cont">
                      <span *ngFor="let offerType of getSelectedOfferTypes()" class="type-item">
                        {{ offerType.label }} <i class="fa fa-close" (click)="removeOfferType(offerType.value)"></i>
                      </span>
                    </div>
                    <small class="text-danger" *ngIf="(offerTypes.touched || offerTypes.dirty) && !offerTypes.valid">
                      Establishment Type is invalid.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-tags-dropdown">Offer Tags</label>
                    <select
                      type="number"
                      id="offer-tags-dropdown"
                      name="offerTags"
                      class="form-control"
                      [(ngModel)]="selectedOfferTags"
                      #offerTags
                    >
                      <option value="null" disabled>Nothing selected</option>
                      <option
                        *ngFor="let item of offerTagsDropdown"
                        value="{{ item.value }}"
                      >
                        {{ item.label }}
                      </option>
                    </select>

                    <div class="offer-tags-items-cont">
                      <span
                        *ngFor="let offerTag of getSelectedOfferTags()"
                        class="tag-item"
                      >
                        {{ offerTag.label }}
                        <i
                          class="fa fa-close"
                          (click)="removeOfferTag(offerTag.value)"
                        ></i>
                      </span>
                    </div>
                    <small
                      class="text-danger"
                      *ngIf="
                        (offerTags.touched || offerTags.dirty) &&
                        !offerTags.valid
                      "
                    >
                      Offer Tag is invalid.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-price-dropdown">Price</label>
                    <select
                      type="number"
                      id="offer-price-dropdown"
                      name="offerPrice"
                      class="form-control"
                      [(ngModel)]="offer.price"
                      #offerPrice
                      [disabled]="!this.offer.establishment.locationId"
                    >
                      <option value="null">{{ this.offer.establishment.locationId ? 'Nothing selected' : 'Select a location first' }}</option>
                      <option
                        *ngFor="let item of priceDropdown"
                        value="{{ item.value }}"
                      >
                        {{ item.label }}
                      </option>
                    </select>
                    <small
                      class="text-danger"
                      *ngIf="
                        (offerPrice.touched || offerPrice.dirty) &&
                        !offerPrice.valid
                      "
                    >
                      Price is invalid.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-latitude-input">Latitude</label>
                    <input
                      type="text"
                      name="latitude"
                      class="form-control"
                      id="establishment-latitude-input"
                      [(ngModel)]="offer.establishment.latitude"
                      #establishmentLatitude="ngModel"
                      [required]="!isStatusDraft"
                      [readonly]="formLocked"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(establishmentLatitude.touched || establishmentLatitude.dirty) && !establishmentLatitude.valid"
                    >
                      Latitude is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-longitude-input">Longitude</label>
                    <input
                      type="text"
                      name="longitude"
                      class="form-control"
                      id="establishment-longitude-input"
                      [(ngModel)]="offer.establishment.longitude"
                      #establishmentLongitude="ngModel"
                      [required]="!isStatusDraft"
                      [readonly]="formLocked"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(establishmentLongitude.touched || establishmentLongitude.dirty) && !establishmentLongitude.valid"
                    >
                      Longitude is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-start-date-picker">Start Date</label>
                    <ch-datepicker
                      (onChange)="startDateChange($event)"
                      [date]="offer.startDate"
                      id="offer-start-date-picker"
                    ></ch-datepicker>
                  </div>

                  <div class="form-group">
                    <label for="offer-expiry-date-picker">Expiry Date</label>
                    <ch-datepicker
                      (onChange)="expiryDateChange($event)"
                      [date]="offer.endDate"
                      id="offer-expiry-date-picker"
                    ></ch-datepicker>
                  </div>

                  <div class="form-group">
                    <label for="offer-max-number-of-people-input">Max People</label>
                    <input
                      type="number"
                      name="maxNumberOfPeople"
                      class="form-control"
                      id="offer-max-number-of-people-input"
                      [(ngModel)]="offer.maxNumberOfPeople"
                      #offerMaxNumberOfPeople="ngModel"
                      min="1"
                      [readonly]="formLocked"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(offerMaxNumberOfPeople.touched || offerMaxNumberOfPeople.dirty) && !offerMaxNumberOfPeople.valid"
                    >
                      Max People should be positive.
                    </small>
                  </div>

                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input
                        id="featured-checkbox"
                        (change)="markFeatured(featuredCh.checked)"
                        #featuredCh
                        type="checkbox"
                        name="featured"
                        [(ngModel)]="offer.featured"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="featured-checkbox">Is Featured?</label>
                    </div>
                  </div>
                </div>

                <div class="col-sm-6 col-md-6">
                  <div class="form-group">
                    <label for="member-edit-name">Image (1440 x 872; Max size: 4MB)</label>
                    <ch-image-upload
                      (onChange)="imageChanged($event)"
                      [resourceId]="offer.imageId"
                      [maxWidth]="1440"
                      [maxHeight]="872"
                    ></ch-image-upload>

                    <small class="text-danger" *ngIf="!isStatusDraft && !offer.imageId"> Image is invalid. </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-click-to-book-dropdown">Click to Book</label>
                    <select
                      name="clickToBook"
                      [(ngModel)]="offer.clickToBook"
                      #offerClickToBook="ngModel"
                      class="form-control"
                      id="offer-click-to-book-dropdown"
                    >
                      <option *ngFor="let type of clickToBookTypes" [ngValue]="type.value">{{ type.label }} </option>
                    </select>
                    <small class="text-danger" *ngIf="(offerClickToBook.touched || offerClickToBook.dirty) && !offerClickToBook.valid">
                      Click to book is invalid.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-phone-input">Booking Phone</label>
                    <input
                      type="text"
                      name="phone"
                      class="form-control"
                      id="establishment-phone-input"
                      [(ngModel)]="offer.establishment.phone"
                      #establishmentPhone="ngModel"
                      [readonly]="formLocked"
                      [required]="!isStatusDraft && phoneRequired()"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(establishmentPhone.touched || establishmentPhone.dirty) && !establishmentPhone.valid"
                    >
                      Booking phone is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-email-input">Booking Email</label>
                    <input
                      type="text"
                      name="email"
                      class="form-control"
                      id="establishment-email-input"
                      [(ngModel)]="offer.establishment.email"
                      #establishmentEmail="ngModel"
                      [readonly]="formLocked"
                      [required]="!isStatusDraft && emailRequired()"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(establishmentEmail.touched || establishmentEmail.dirty) && !establishmentEmail.valid"
                    >
                      Booking email is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-website-input">Website</label>
                    <input
                      type="text"
                      name="website"
                      class="form-control"
                      id="establishment-website-input"
                      [(ngModel)]="offer.establishment.website"
                      #establishmentWebsite="ngModel"
                      [readonly]="formLocked"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(establishmentWebsite.touched || establishmentWebsite.dirty) && !establishmentWebsite.valid"
                    >
                      Website is requited.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-booking-url-input">Booking URL</label>
                    <input
                      type="text"
                      name="bookingUrl"
                      class="form-control"
                      id="offer-booking-url-input"
                      [(ngModel)]="offer.bookingUrl"
                      #offerBookingUrl="ngModel"
                      [readonly]="formLocked"
                      [required]="!isStatusDraft && bookingUrlRequired()"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(offerBookingUrl.touched || offerBookingUrl.dirty) && !offerBookingUrl.valid"
                    >
                      Booking URL is requited.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-twitter-input">Twitter</label>
                    <div class="input-group">
                      <span class="input-group-addon"> <b>@</b> </span>
                      <input
                        type="text"
                        name="twitter"
                        class="form-control"
                        id="establishment-twitter-input"
                        [(ngModel)]="offer.establishment.twitter"
                        #establishmentTwitter="ngModel"
                        [readonly]="formLocked"
                        pattern="^(?![@]).*"
                      />
                    </div>
                    <small
                      class="text-danger"
                      *ngIf="(establishmentTwitter.touched || establishmentTwitter.dirty) && !establishmentTwitter.valid"
                    >
                      Twitter is invalid.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="establishment-instagram-input">Instagram</label>
                    <input
                      type="text"
                      name="instagram"
                      class="form-control"
                      id="establishment-instagram-input"
                      [(ngModel)]="offer.establishment.instagram"
                      #establishmentInstagram="ngModel"
                      [readonly]="formLocked"
                    />
                    <small
                      class="text-danger"
                      *ngIf="(establishmentInstagram.touched || establishmentInstagram.dirty) && !establishmentInstagram.valid"
                    >
                      Instagram is invalid.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="reservation-type-dropdown">Reservation Type</label>
                    <select
                      type="number"
                      name="reservationType"
                      [(ngModel)]="offer.reservationType"
                      #establishmentReservationType="ngModel"
                      class="form-control"
                      [required]="!isStatusDraft"
                      id="reservation-type-dropdown"
                    >
                      <option selected value="null" disabled>Nothing selected</option>
                      <option *ngFor="let type of reservationTypes" value="{{ type.value }}">{{ type.label }}</option>
                    </select>
                    <small
                      class="text-danger"
                      *ngIf="
                        (establishmentReservationType.touched || establishmentReservationType.dirty) && !establishmentReservationType.valid
                      "
                    >
                      Reservation Type is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <label for="offer-offer-type-dropdown">Offer Type</label>
                    <select
                      name="offerType"
                      [(ngModel)]="offer.offerType"
                      #offerType="ngModel"
                      class="form-control"
                      id="offer-offer-type-dropdown"
                    >
                      <option *ngFor="let type of offerTypeTypes" [ngValue]="type.value">{{ type.label }} </option>
                    </select>
                    <small class="text-danger" *ngIf="(offerType.touched || offerType.dirty) && !offerType.valid">
                      Offer type is invalid.
                    </small>
                  </div>

                  <div class="form-group" *ngIf="showRedemptionUrl()">
                    <label for="offer-redemption-url-input">Redemption URL</label>
                    <input
                      type="text"
                      name="redemptionUrl"
                      class="form-control"
                      id="offer-redemption-url-input"
                      [(ngModel)]="offer.redemptionUrl"
                      #redemptionUrl="ngModel"
                      [required]="!isStatusDraft && redemptionUrlRequired()"
                      [readonly]="formLocked"
                    />
                    <small class="text-danger" *ngIf="(redemptionUrl.touched || redemptionUrl.dirty) && !redemptionUrl.valid">
                      Redemption URL is required.
                    </small>
                  </div>

                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input
                        id="has-party-size-checkbox"
                        (change)="markHasPartySize(hasPartySizeCh.checked)"
                        #hasPartySizeCh
                        type="checkbox"
                        name="hasPartySize"
                        [(ngModel)]="offer.hasPartySize"
                        class="custom-control-input"
                      />
                      <label class="custom-control-label" for="has-party-size-checkbox">Has Party Size?</label>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div style="display: flex; gap: 30px;">
                  <div class="form-group" style="flex-grow: 1;">
                    <label for="offer-description-input">Description</label>
                    <div>
                      <ch-wysiwyg
                        [value]="initialDesription"
                        (onChange)="updateDescription($event)"
                        id="offer-description-input"
                      ></ch-wysiwyg>
                      <small class="text-danger" *ngIf="!isStatusDraft && !clearDescription()">
                        Description is required.
                      </small>
                    </div>
                  </div>
                  <div class="form-group" style="flex-grow: 1;">
                    <label for="offer-new-app-description-input">New App Description</label>
                    <div>
                      <ch-wysiwyg
                        [value]="initialNewAppDescription"
                        (onChange)="updateNewAppDescription($event)"
                        id="offer-new-app-description-input"
                      ></ch-wysiwyg>
                      <!-- <small class="text-danger" *ngIf="!isStatusDraft && !clearNewAppDescription()">
                        New App Description is required.
                      </small> -->
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label for="offer-notes-input">Notes</label>
                  <div>
                    <ch-wysiwyg [value]="initialNotes" (onChange)="updateNotes($event)" id="offer-notes-input"></ch-wysiwyg>
                  </div>
                </div>

                <div>
                  <h3>Contract Information</h3>

                  <div class="form-group col-sm-6 col-md-6">
                    <label for="offer-contract-start-date-picker">Contract Start Date</label>
                    <ch-datepicker
                      (onChange)="contractStartDateChange($event)"
                      [date]="offer.contractStartDate"
                      id="offer-contract-start-date-picker"
                    ></ch-datepicker>
                  </div>

                  <div class="form-group col-sm-6 col-md-6">
                    <label for="offer-contract-start-date-picker">Contract Renewal Date</label>
                    <ch-datepicker
                      (onChange)="contractRenewalDateChange($event)"
                      [date]="offer.contractRenewalDate"
                      id="offer-contract-start-date-picker"
                    ></ch-datepicker>
                  </div>

                  <div class="form-group col-sm-6 col-md-6">
                    <label for="offer-contract-listing-fee-input">Listing Fee</label>
                    <div class="input-group">
                      <span class="input-group-addon"> <b>£</b> </span>
                      <input
                        type="number"
                        name="listingFee"
                        class="form-control"
                        id="offer-contract-listing-fee-input"
                        [(ngModel)]="offer.listingFee"
                        #listingFee="ngModel"
                        [readonly]="formLocked"
                      />
                    </div>
                  </div>

                  <div class="form-group col-sm-6 col-md-6">
                    <label for="offer-contract-payment-period-dropdown">Payment Period</label>
                    <select
                      name="contractPaymentPeriod"
                      [(ngModel)]="offer.contractPaymentPeriod"
                      #contractPaymentPeriod="ngModel"
                      class="form-control"
                      id="offer-contract-payment-period-dropdown"
                    >
                      <option value="null">Nothing selected</option>
                      <option *ngFor="let type of offerContractPaymentPeriods" [ngValue]="type.value">{{ type.label }} </option>
                    </select>
                  </div>

                  <div class="form-group col-sm-6 col-md-6">
                    <label for="offer-number-of-covers-input">Number of covers</label>
                    <div class="input-group">
                      <input
                        type="number"
                        name="numberOfCovers"
                        class="form-control"
                        id="offer-number-of-covers-input"
                        [(ngModel)]="offer.numberOfCovers"
                        #numberOfCovers="ngModel"
                        [readonly]="formLocked"
                      />
                    </div>
                  </div>

                  <div class="form-group col-sm-6 col-md-6">
                    <label for="offer-average-spend-per-head-input">Average Spend Per Head</label>
                    <div class="input-group">
                      <span class="input-group-addon"> <b>£</b> </span>
                      <input
                        type="number"
                        name="averageSpendPerHead"
                        class="form-control"
                        id="offer-average-spend-per-head-input"
                        [(ngModel)]="offer.averageSpendPerHead"
                        #averageSpendPerHead="ngModel"
                        [readonly]="formLocked"
                      />
                    </div>
                  </div>

                  <div class="form-group col-sm-12 col-md-12">
                    <label for="offer-contract-group-name-input">Group Name</label>
                    <input
                      type="text"
                      name="groupName"
                      class="form-control"
                      id="offer-contract-group-name-input"
                      [(ngModel)]="offer.groupName"
                      #groupName="ngModel"
                      [readonly]="formLocked"
                    />
                  </div>
                </div>


                <div *ngIf="dataLoaded">
                  <ch-contacts [(ngModel)]="offer.establishment" name="offerEstablishmentContacts" [shouldValidate]='!isStatusDraft'></ch-contacts>
                </div>

                <div name="availabilitiesSlotsForm">
                  <h3>Offers</h3>
                  <div *ngIf="dataLoaded">
                    <div *ngFor="let slot of offer.offerAvailabilitySlots; let i = index" class="availability-item">
                      <ch-availability-item
                        [(ngModel)]="offer.offerAvailabilitySlots[i]"
                        [name]="slotName(i)"
                        (cancel)="removeSlot(i)"
                      ></ch-availability-item>
                    </div>
                  </div>
                  <small class="text-danger" *ngIf="!isStatusDraft && !validateSlots()">
                    At least one slot is required.
                  </small>
                </div>

                <div class="availability-add-cont">
                  <button type="button" class="btn btn-success" aria-label="Close" (click)="addAvailabilitySlot()">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>

              <div style="margin-top: 40px;">
                <button id='offerEditDelete' *ngIf="offerId" type="button" class="btn btn-danger" (click)="delete()">Delete</button>
                <span *ngIf="offerId" class="btn-mid">
                  <button id='offerEditDuplicate' type="button" class="btn btn-info" (click)="duplicateOffer()" [disabled]="offerForm.dirty">
                    Duplicate Offer
                  </button>
                </span>
                <span class="btn-right">
                  <button id='offerPreview' type='button' class="btn btn-info" (click)="showOfferPreviewDialog()">Preview</button>
                  <button id='offerFeatured' type='button' class="btn btn-info" (click)="toggleOfferNew()">{{ isOfferNew ? 'Mark as not New': 'Mark as New' }}</button>
                  <button *ngIf='offerId' id='offerStatusChange' type='button' class="btn btn-info" (click)='changeStatus()'>{{ changeStatusText }}</button>
                  <button id='offerEditCancel' type="button" class="btn btn-secondary" (click)="navigateToMainPage()">Cancel</button>
                  <button id='offerEditSave' type="submit" class="btn btn-primary" [disabled]="!offerForm.valid">Save</button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-3 col-md-3" >
          <div class="card mb-9" *ngIf="offerId">
            <div class="card-header">Statistics</div>
            <div class="card-body">
              <div class="panel-info">
                <p *ngIf="!dataLoaded">...</p>
                <div *ngIf="dataLoaded">
                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px;">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ offer.viewsCount }}</div>
                        <div class="text-uppercase font-weight-bold">Views</div>
                      </a>
                    </div>
                  </div>

                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px;">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ offer.redemptionsCount }}</div>
                        <div class="text-uppercase font-weight-bold">Redemptions</div>
                      </a>
                    </div>
                  </div>

                  <div class="card card-inverse card-important bg-primary" style="margin-bottom: 15px;">
                    <div class="card-body text-center">
                      <a class="text-white" style="text-decoration: none;">
                        <div class="display-6 font-weight-bold">{{ offer.lastRedeemedAt | dateFormat }}</div>
                        <div class="text-uppercase font-weight-bold">Last Redemption</div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Offer Tag legend -->
          <div class='mb-9' style='display: flex;flex-direction: column; justify-content: center;'>
            <span class='h3 text-center'>Offer Tags</span>
            <div class='example-tag primary-tag mb-2'>
              <span>Surfaced in the App</span>
            </div>
            <div class='example-tag secondary-tag'>
              <span>Search Field only</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<ch-offer-preview-modal-dialog
  [show]="showOfferPreview"
  [data]="offer"
  (onClose)="closeOfferPreviewDialog()"
></ch-offer-preview-modal-dialog>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/offer-edit/offer-edit.component.html